import {
  DataLoad,
  BaseList,
  PowerfulBtn,
  DataList,
  DataTable,
  QuickForm,
  SelectExtend,
  
} from "quick-vue-components";
import FastTable from "quick-vue-components/DataTable/src/FastTable/FastTable.vue";
import { $t } from '@user-center/utils/i18n'

import type { QuickFormPropsType, RenderNodesType } from "quick-vue-components/QuickForm/src/index.tsx";

import { ElButton, } from "element-plus";


export default function init(){
  FastTable.props.indexLabel.default=$t('text.indexNo')

  BaseList.props.searchBarWrapper.default= function defaultSearchBarWrapper(
    setSearchFormAttrs: Partial<QuickFormPropsType>,
    SearchFormVnode:any
  ): RenderNodesType {
    (setSearchFormAttrs as any).buttonGroupColConfig = false;
    return (
      <div class="base-list-searchbar-wrapper">
        {SearchFormVnode}
      </div>
    );
  }

}